// import { toast } from 'react-toastify';
import { useMutation /* useQueryClient,  useQuery */ } from 'react-query';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import api from 'client';
// import { Typography } from '@mui/material';
import { routes } from 'const';

export default () => {
  const stripe = useStripe();
  const elements = useElements();

  const deleteCardMutation = useMutation(() => api.delete(`/apis/v2/patient/payment_method`), {
    onSuccess: () => {},
    onError: () => {},
  });

  const createCardMutation = useMutation(() => api.post(`/apis/v2/patient/payment_method`), {
    onSuccess: () => {},
    onError: () => {},
  });

  const updateCardMutation = useMutation(async ({ paymentInformation, defaultStripeCard }) => {
    if (paymentInformation.complete) {
      const stripeResponse = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: `${document.location.origin}${routes.payment}`,
        },
        redirect: 'if_required',
      });

      const { error: stripeError } = stripeResponse;
      if (stripeError) {
        throw new Error(stripeError.message);
      } else {
        await api
          .put('/apis/v2/patient/payment_method', {
            payment_method_id: stripeResponse.setupIntent.payment_method,
            default_stripe_card: defaultStripeCard,
          })
          .then(() => {
            window.location.reload(false);
          })
          .catch(() => {
            window.location.reload(false);
          });
      }
    }
  });

  return {
    addNewCard: createCardMutation.mutateAsync,
    updateCard: updateCardMutation.mutateAsync,
    deleteCard: deleteCardMutation.mutateAsync,
  };
};
